import { useSearchParams } from 'next/navigation'

import styles from './title.module.scss'

export default function Title(): JSX.Element {
  const query = useSearchParams()
  const searchQuery = query?.get('query')

  if (searchQuery) {
    return <h2 className={styles.title}>Showing ‘{searchQuery}’ related articles</h2>
  }
  return <></>
}
